import { render, staticRenderFns } from "./dlgBedSelector.vue?vue&type=template&id=748e2d5b"
import script from "./dlgBedSelector.vue?vue&type=script&lang=js"
export * from "./dlgBedSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports